import './lib/sentry';
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import App from "./App.tsx";
import "./i18n";
import "./index.css";

// Register service worker outside Capacitor native context.
// The update prompt is handled in the usePwaUpdate hook (consumed by App).
const isCapacitorNative =
  typeof (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor !== "undefined" &&
  (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor?.isNativePlatform?.();

if (!isCapacitorNative) {
  window.__pwa_update_sw__ = registerSW({ immediate: false });
}

createRoot(document.getElementById("root")!).render(<App />);
